import { motion, AnimatePresence } from 'framer-motion';
import Button from '@/components/ui/Button';

export default function BadgeUnlockModal({ data, onClose }) {
  return (
    <AnimatePresence>
      {data && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-6"
          style={{ background: 'radial-gradient(circle, rgba(155,89,182,0.3) 0%, rgb(var(--hc-bg) / 0.92) 100%)' }}
        >
          <motion.div
            initial={{ scale: 0.3, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.3, opacity: 0 }}
            transition={{ type: 'spring', damping: 12, stiffness: 200 }}
            className="parchment-card w-full max-w-xs p-5 text-center"
          >
            <div className="mb-3 text-7xl">🏅</div>
            <div className="mb-1 text-sm font-bold uppercase tracking-widest text-gem">Nova medalha</div>
            <h2 className="mb-2 font-urban text-xl font-bold text-fg">{data?.name}</h2>
            <p className="mb-4 text-sm text-fg/70">{data?.description || 'Conquistaste uma nova marca na cidade.'}</p>
            <div className="mb-5 text-center text-fg">
              <div className="text-2xl">⭐</div>
              <div className="font-bold">+{data?.xpReward || 0} XP</div>
            </div>
            <Button variant="gold" fullWidth onClick={onClose}>Incrível</Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
